import React from "react";

// Pixel-art child avatar (16-bit sprite) for the Nintendo-style hub.
export const Avatar = ({ pos, facing, moving }) => {
  const flip = facing === "left" ? "scaleX(-1)" : "scaleX(1)";
  return (
    <div
      data-testid="avatar"
      className="absolute z-30 pointer-events-none"
      style={{ left: `${pos.x}%`, top: `${pos.y}%`, transform: "translate(-50%, -78%)" }}
    >
      {/* ground shadow */}
      <div className="mx-auto h-2 w-9 rounded-full bg-black/35 blur-[2px]" />
      <div className={moving ? "avatar-bob -mt-[62px]" : "-mt-[62px]"} style={{ transform: flip }}>
        <img
          src="/home/kid_back.png"
          alt="you"
          className="pixelated h-[64px] w-[64px] object-contain"
          style={{ filter: "drop-shadow(0 3px 2px rgba(0,0,0,0.5))" }}
        />
      </div>
    </div>
  );
};
